import { ITimelineToggleState } from '~src/store/timeline/toggle/types';
import { IStudioState } from '~src/store/types';

const getTimelineToggleState = (state: IStudioState): ITimelineToggleState => {
    return state.timeline.toggles;
};

export { getTimelineToggleState };
